import { InfoCircleFilled } from '@ant-design/icons';
import React from 'react';
import { useTranslate } from '@tolgee/react';
import { isTiKTok } from 'lib/utils/isTikTok';

const AuthShopTips = (props: { platform: General.PlatformTunnel }) => {
  const { platform } = props;
  const { t } = useTranslate();

  let text;
  if (platform === 'shopee') {
    text = t('authShop.shopeeAuthTips');
  }
  if (isTiKTok(platform)) {
    text = t('authShop.tiktokAuthTips');
  }
  if (platform === 'lazada') {
    text = t(
      '依据 Lazada 官方规定，所有本土店铺需先登录服务市场并完成第三方应用（ChatPlusAI）的订购后才能进行授权。',
    );
  }

  const textNode = text ? (
    <div className=" flex items-center bg-[#fff7f7] px-4 py-2">
      <InfoCircleFilled style={{ color: 'var(--ant-error-color)' }} size={14} />
      <span className="ml-2 text-fill-600 font-medium">{text}</span>
    </div>
  ) : null;

  return <div className="absolute top-0 right-0 left-0">{textNode}</div>;
};

export default React.memo(AuthShopTips);
